<template>
    <div id="app" :class=" 'grid__main-' + getColor">
        <loader v-show="readyStat"></loader>
        <div  @click="ViwerMenuEnter" :class="openMenu +' '+ 'grid__left-'+getColor">
                <div class="leftMenuUpArea">
                    <div class="mainLogo__wrap">
                        <a href="#" class="mainLogo__link">IQ</a>
                    </div>
                    <div class="mainLogo__wrap">
                        <div class="main__avatar f-ava">
                            <router-link v-for="(item, index) in personalItem" :key="index" :to="item.url" v-if="login !== ''">
                                <user-avatar></user-avatar>
                            </router-link>
                            <img class="f-ava__img" v-if="login === ''" src="./assets/img/no_login.jpg">
                        </div>
                    </div>
                    <!-- Left menu -->
                    <div class="leftColumnMenu__wrap">
                        <div v-if="setUnreadNewMessage!==0" class="leftColumnMenu_alert">
                        </div>
                        <div class="leftColumnMenu">
                            <router-link v-for="(item, index) in menuItems"
                                :key="index"
                                :to="item.url"
                                tag="div"
                                :class="'leftColumnMenu__item-black'"
                                active-class="leftColumnMenu__item leftColumnMenu__item-active">
                                <a>
									<svg-icon icon-class="icon" :icon-name="item.class" icon-size="0 0 46 46" icon-fill="#cae9ff"></svg-icon>
								</a>
                            </router-link>
                        </div>
                    </div>
                </div>
                <div class="leftMenuDownArea">
                        <!--<div :class="'leftColumnMenu__item-down-'+getColor" @click="SetTheme">
                            <a class="icon-color-theme main-menu-item-down" href="#"></a>
                        </div>
                        <div class="leftColumnMenu__item-down">
                            <a class="icon-lang-ru" href="#"></a>
                        </div>-->
                    <svg width="30px" height="30px" aria-hidden="true" focusable="false" data-prefix="fab" data-icon="viber" class="svg-inline--fa fa-viber fa-w-16" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path fill="#574e92" d="M444 49.9C431.3 38.2 379.9.9 265.3.4c0 0-135.1-8.1-200.9 52.3C27.8 89.3 14.9 143 13.5 209.5c-1.4 66.5-3.1 191.1 117 224.9h.1l-.1 51.6s-.8 20.9 13 25.1c16.6 5.2 26.4-10.7 42.3-27.8 8.7-9.4 20.7-23.2 29.8-33.7 82.2 6.9 145.3-8.9 152.5-11.2 16.6-5.4 110.5-17.4 125.7-142 15.8-128.6-7.6-209.8-49.8-246.5zM457.9 287c-12.9 104-89 110.6-103 115.1-6 1.9-61.5 15.7-131.2 11.2 0 0-52 62.7-68.2 79-5.3 5.3-11.1 4.8-11-5.7 0-6.9.4-85.7.4-85.7-.1 0-.1 0 0 0-101.8-28.2-95.8-134.3-94.7-189.8 1.1-55.5 11.6-101 42.6-131.6 55.7-50.5 170.4-43 170.4-43 96.9.4 143.3 29.6 154.1 39.4 35.7 30.6 53.9 103.8 40.6 211.1zm-139-80.8c.4 8.6-12.5 9.2-12.9.6-1.1-22-11.4-32.7-32.6-33.9-8.6-.5-7.8-13.4.7-12.9 27.9 1.5 43.4 17.5 44.8 46.2zm20.3 11.3c1-42.4-25.5-75.6-75.8-79.3-8.5-.6-7.6-13.5.9-12.9 58 4.2 88.9 44.1 87.8 92.5-.1 8.6-13.1 8.2-12.9-.3zm47 13.4c.1 8.6-12.9 8.7-12.9.1-.6-81.5-54.9-125.9-120.8-126.4-8.5-.1-8.5-12.9 0-12.9 73.7.5 133 51.4 133.7 139.2zM374.9 329v.2c-10.8 19-31 40-51.8 33.3l-.2-.3c-21.1-5.9-70.8-31.5-102.2-56.5-16.2-12.8-31-27.9-42.4-42.4-10.3-12.9-20.7-28.2-30.8-46.6-21.3-38.5-26-55.7-26-55.7-6.7-20.8 14.2-41 33.3-51.8h.2c9.2-4.8 18-3.2 23.9 3.9 0 0 12.4 14.8 17.7 22.1 5 6.8 11.7 17.7 15.2 23.8 6.1 10.9 2.3 22-3.7 26.6l-12 9.6c-6.1 4.9-5.3 14-5.3 14s17.8 67.3 84.3 84.3c0 0 9.1.8 14-5.3l9.6-12c4.6-6 15.7-9.8 26.6-3.7 14.7 8.3 33.4 21.2 45.8 32.9 7 5.7 8.6 14.4 3.8 23.6z"></path></svg>
                    <svg width="30px" height="30px" aria-hidden="true" focusable="false" data-prefix="fab" data-icon="telegram" class="svg-inline--fa fa-telegram fa-w-16" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 496 512"><path fill="#0088cc" d="M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm121.8 169.9l-40.7 191.8c-3 13.6-11.1 16.9-22.4 10.5l-62-45.7-29.9 28.8c-3.3 3.3-6.1 6.1-12.5 6.1l4.4-63.1 114.9-103.8c5-4.4-1.1-6.9-7.7-2.5l-142 89.4-61.2-19.1c-13.3-4.2-13.6-13.3 2.8-19.7l239.1-92.2c11.1-4 20.8 2.7 17.2 19.5z"></path></svg>
                    <svg width="30px" height="30px" aria-hidden="true" focusable="false" data-prefix="fab" data-icon="whatsapp" class="svg-inline--fa fa-whatsapp fa-w-14" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path fill="#1ebea5" d="M380.9 97.1C339 55.1 283.2 32 223.9 32c-122.4 0-222 99.6-222 222 0 39.1 10.2 77.3 29.6 111L0 480l117.7-30.9c32.4 17.7 68.9 27 106.1 27h.1c122.3 0 224.1-99.6 224.1-222 0-59.3-25.2-115-67.1-157zm-157 341.6c-33.2 0-65.7-8.9-94-25.7l-6.7-4-69.8 18.3L72 359.2l-4.4-7c-18.5-29.4-28.2-63.3-28.2-98.2 0-101.7 82.8-184.5 184.6-184.5 49.3 0 95.6 19.2 130.4 54.1 34.8 34.9 56.2 81.2 56.1 130.5 0 101.8-84.9 184.6-186.6 184.6zm101.2-138.2c-5.5-2.8-32.8-16.2-37.9-18-5.1-1.9-8.8-2.8-12.5 2.8-3.7 5.6-14.3 18-17.6 21.8-3.2 3.7-6.5 4.2-12 1.4-32.6-16.3-54-29.1-75.5-66-5.7-9.8 5.7-9.1 16.3-30.3 1.8-3.7.9-6.9-.5-9.7-1.4-2.8-12.5-30.1-17.1-41.2-4.5-10.8-9.1-9.3-12.5-9.5-3.2-.2-6.9-.2-10.6-.2-3.7 0-9.7 1.4-14.8 6.9-5.1 5.6-19.4 19-19.4 46.3 0 27.3 19.9 53.7 22.6 57.4 2.8 3.7 39.1 59.7 94.8 83.8 35.2 15.2 49 16.5 66.6 13.9 10.7-1.6 32.8-13.4 37.4-26.4 4.6-13 4.6-24.1 3.2-26.4-1.3-2.5-5-3.9-10.5-6.6z"></path></svg>
                </div>
        </div>
        <div class="grid__center">
            <div class="grid__header">
                    <sig-header></sig-header>
            </div>
                <transition name="fade" appear mode="out-in">
                <router-view />
                </transition>
        </div>
        <transition name="show">
        <nav-text v-show="leftMenu" @openReg="openReg($event)" @openSign="openSign($event)"></nav-text>
        </transition>
        <transition name="show">
            <sig-login-reg v-if="regForm" :reg="selectReg" :sign="selectSign" @close="closeForm($event)">
            </sig-login-reg>
        </transition>
        <transition enter-active-class="animated fadeIn"
                                leave-active-class="animated fadeOut">
        <div class="overlay" v-show="overlay" @mouseenter="Viwer">
        </div>
        </transition>
    </div>
</template>

<script>
import NavigateText from "./components/left-menu/sig-navigate-text";
import LoginReg from "./components/login-and-reg-forms/sig-login-and-reg";
import Header from "./components/header/sig-header";
import Preloader from "./components/sig-preloader";
import FullScreenChart from "./components/sig-fullscreen-chart";
import UserAvatar from "./components/ui-components/user-avatar";
import { socketStream } from "./model/socket-stream.js";
import { mapGetters } from "vuex";
import SvgIcon from "./components/ui-components/svg-icon";

export default {
  components: {
    "sig-login-reg": LoginReg,
    "nav-text": NavigateText,
    "sig-header": Header,
    "loader":Preloader,
    "fullscreen":FullScreenChart,
    "user-avatar":UserAvatar,
    "svg-icon": SvgIcon
  },
  name: "app",
  data() {
    return {
      regForm: false,
      leftMenu: false,
      overlay: false,
      openMenu: "",
      selectReg: false,
      selectSign: false,
      color:'',
      showPreloader:true,
      symbol:''
    };
  },
  computed: {
    ...mapGetters({
        name: "auth/getName",
        login: "auth/getLogin",
        getColor: "color/getColor",
        personalItem: 'menu/personal',
        getScreen: 'menu/screen',
        readyStat:'ready/getReady',
        infoRoom:'chat/getUsersInRoom',
        getStatistics: 'accountstat/getStatistics',
        getOrders:"positions/getAllPositions"
    }),
    menuItems() {
      return this.$store.getters["menu/items"];
    },
    showLoad () {
        let stat = this.stat;
        let show = null;
        if(!stat)
            show = false;
        else
            show = true;
        return show;
    },
    setUnreadNewMessage() {
            let cnt = 0;
            if(this.infoRoom.length !== 0) {
                for(let i = 0; i < this.infoRoom.length; i++){
                    if(this.infoRoom[i].newMessages === true)
                        cnt++;
                }
            }
        return cnt;
    }
  },
    methods: {
        ViwerForm() {
            return (this.regForm = !this.regForm);
        },
        ViwerMenuEnter() {
            this.leftMenu = !this.leftMenu;
            this.overlay = !this.overlay;
            this.openMenu = 'menu-active-'+ this.getColor;
        },
        Viwer() {
            if (this.regForm === true) {
                this.leftMenu = false;
                this.openMenu = "";
                this.overlay = true;
            } else {
                this.leftMenu = false;
                this.overlay = false;
            }
        },
        SetTheme() {
            this.openMenu == 'menu-active-black' ? this.openMenu = 'menu-active-white' : this.openMenu = 'menu-active-black'
            this.$store.dispatch('color/setColor')
        },
        closeForm(e) {
            this.regForm = e;
        },
        openReg(e) {
            this.selectReg = e;
            this.selectSign = !e;
            this.regForm = e;
            this.leftMenu = !e;
        },

        openSign(e) {
            this.selectSign = e;
            this.selectReg = !e;
            this.regForm = e;
            this.leftMenu = !e;
        },
        setStat() {
            let stat = this.getStatistics(this.symbol);
            if (!stat) {
                return;
            }
            this.$store.dispatch('ready/statReady');
        }
    },

    created() {
        socketStream.connect(
            this.$store.getters['api/getWssUri']
        );
        this.$store.dispatch("tradingspecs/initialize");
        this.$store.dispatch("quotes/subscribe");
        this.$store.dispatch("accountstat/initialize");
        this.$store.dispatch("accountevents/subscribeOnPositionEvents");
        this.$store.dispatch("positions/initialize");
        this.$store.dispatch("closSummary/initialize");
        this.$store.dispatch('accountevents/evetntsForStream');
        this.color = this.$store.getters['color/getColor'];
        if (localStorage.getItem('infoUser')) {
            try {
                let cred = JSON.parse(localStorage.getItem('infoUser'));
                let payload = { Login: cred.User.Login, Password: cred.User.Password };
                this.$store.dispatch('auth/performLogin', payload);
                this.$store.dispatch('chat/connectWithCreds', {
				    login: cred.User.Login,
				    password: cred.User.Password
                });
            } catch(e) {
                localStorage.removeItem('infoUser');
            }
        } else {
            this.$store.dispatch('chat/connectWithCreds', {
				    login: 'unname',
				    password: 'MSLAATbzX4vxAorjq'
                });
        }

        if (localStorage.getItem('settingsDesktop')) {
            /*try {
                let settings = JSON.parse(localStorage.getItem('settingsDesktop'));
                this.$store.dispatch('usersets/setSettingsFromStorage', settings);
            } catch(e) {*/
                localStorage.removeItem('settingsDesktop');
        }
        subscribeOnUpdate(this.$store, this.symbol, isFirstObtained => {
            //if (!this.symbol || !this.symbol.length) {
                this.setStat();
            //}
        });
        // может быть, данные уже есть в store
        this.setStat();
    }
}
function subscribeOnUpdate(store, symbol, handler) {
    store.dispatch("accountstat/subscribeOnUpdate", {
        symbol: symbol,
        callback: {
            id: `app-component`,
            handler: handler
        }
    });

}

</script>

<style lang="less">

@import "less/_libs/normalize/normalize.less";
@import "less/_libs/animate/animate.less";


.overlay {
  width: 100vw;
  height: 100vh;
  position: absolute;
  background-color: rgba(0, 0, 0, 0.55);
  z-index: 8;
}
.leftColumnMenu_alert {
    background: #00ffd0;
    border-radius: 10px;
    text-align: center;
    color:#324258;
    width: 10px;
    height: 10px;
    padding-top: 4px;
    box-sizing: border-box;
    position: absolute;
    top:50px;
    left: 38px;
}
.leftMenuDownArea {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    svg {
        margin: 8px 0px 8px 0px;
    }
}

.route-view {
  padding: 10px;
  text-align: center;
}

.main-left-pane {
  max-width: 220px;
  width: 220px;
}

.nav-item a {
  font-size: 12px;
}

.nav-item-active a {
  color: #374b62;
  text-decoration: none;
  background-color: #cae9ff;
  padding: 2px;
  width: 72px;
}

.menu-active-black {
  background-color: #374b62 !important;
}
.menu-active-white {
  background-color: #fff !important;
}

.show-enter {
  opacity: 0;
}

.show-enter-active {
  transition: opacity 0.5s;
}

.show-leave-active {
  transition: opacity 0.5s;
  opacity: 0;
}

.fade-enter-active {
  animation: slideIn 0.9s !important;
}

.fade-leave-active {
  animation: slideOut 0.9s forwards !important;
}

@keyframes slideIn {
  from {
    transform: translateX(-100vw);
  }
  to {
    transform: translateX(0px);
  }
}

@keyframes slideOut {
  from {
    transform: translateX(0px);
  }
  to {
    transform: translateX(-100vw);
  }
}

.btn-slim {
  padding: 0px 6px 2px 6px;
  margin: 4px;
}
</style>
